var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0459 8.14812C2.0459 7.04355 2.94133 6.14812 4.0459 6.14812H7.0459L8.96865 4.34241C9.33948 3.99415 9.82908 3.80029 10.3378 3.80029H13.754C14.2627 3.80029 14.7523 3.99415 15.1231 4.34241L17.0459 6.14812H20.0459C21.1505 6.14812 22.0459 7.04355 22.0459 8.14812V19.8003C22.0459 20.9049 21.1505 21.8003 20.0459 21.8003H4.0459C2.94133 21.8003 2.0459 20.9049 2.0459 19.8003V8.14812Z",
    stroke: "#339999",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5459,
    cy: 9.30029,
    r: 1.5,
    fill: "#339999"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0459,
    cy: 13.8003,
    r: 4,
    stroke: "#339999",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraGreen);
export default __webpack_public_path__ + "static/media/camera_green.56ebbe6d7bed7ebc3b1a1932a7f93b00.svg";
export { ForwardRef as ReactComponent };